import cart from "../../assets/cart.svg";
import { NodeStates, StateManager } from "../../build/types";
import { useInteractionStates } from "../../hooks/useInteractionStates";
import DynamicIcon from "../DynamicIcon";
import {
    getColorsFromInteractiveStates,
    getCompoundStyle,
    getStateColorsForBuilder,
    getStateStyleForBuilder,
    getStylesFromInteractiveStates
} from "../helpers";

const SimpleCartHeader = ({
    name,
    dividerBg,
    hideCart,
    cartIcon,
    closeCartIcon,
    titleStyle,
    stateManager,
    disabled,
    builder,
    nodeState
}: {
    dividerBg: string;
    name?: string;
    hideCart?: () => void;
    cartIcon?: React.ReactElement;
    closeCartIcon?: { src?: string; style?: React.CSSProperties; colors?: string[] };
    titleStyle?: React.CSSProperties;
    stateManager?: StateManager;
    disabled?: boolean;
    builder?: boolean;
    nodeState?: NodeStates;
}) => {
    const { setElement, states } = useInteractionStates<HTMLDivElement>();

    let CloseCartIcon = (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12.0001L10.6 12.0001L5 12.0001" stroke="#3D4C66" strokeLinecap="round" />
            <path d="M9 16.0001L5 12.0001" stroke="#3D4C66" strokeLinecap="round" />
            <path d="M9 8.00006L5 12.0001" stroke="#3D4C66" strokeLinecap="round" />
        </svg>
    );

    if (builder) {
        if (closeCartIcon?.src) {
            const style = getCompoundStyle({
                otherStyle: closeCartIcon.style,
                stateStyle: getStateStyleForBuilder(stateManager, nodeState, "expandedNode_closeIcon_style")
            });
            const colors =
                getStateColorsForBuilder(stateManager, nodeState, "expandedNode_closeIcon_colors") || closeCartIcon.colors;
            CloseCartIcon = <DynamicIcon name={closeCartIcon.src} style={style} colors={colors} />;
        }

        return (
            <header>
                <div className="row" style={dividerBg ? { borderColor: dividerBg } : {}}>
                    <div className="cart">
                        {cartIcon ? cartIcon : <img src={cart} />}
                        <span style={titleStyle}>{name}</span>
                    </div>
                    <div onClick={hideCart}>{CloseCartIcon}</div>
                </div>
            </header>
        );
    } else {
        if (closeCartIcon?.src) {
            const style = getStylesFromInteractiveStates({
                states,
                defaultStyle: closeCartIcon.style,
                stateManager,
                paths: ["expandedNode_closeIcon_style"],
                ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
            });

            const colors = getColorsFromInteractiveStates({
                states,
                stateManager,
                paths: ["expandedNode_closeIcon_colors"],
                defaultColors: closeCartIcon.colors,
                ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
            });

            CloseCartIcon = <DynamicIcon name={closeCartIcon.src} style={style} colors={colors} />;
        }

        return (
            <header>
                <div className="row" style={dividerBg ? { borderColor: dividerBg } : {}}>
                    <div className="cart">
                        {cartIcon ? cartIcon : <img src={cart} />}
                        <span style={titleStyle}>{name}</span>
                    </div>
                    <div onClick={hideCart} ref={setElement}>
                        {CloseCartIcon}
                    </div>
                </div>
            </header>
        );
    }
};
export default SimpleCartHeader;
